import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_HOST = "https://syni.ai";
const DEFAULT_OG = "/og-default.png";
const OG_W = 1536;
const OG_H = 1024;

/**
 * SEO — per-page meta. Pass `path` starting with `/`.
 * `ogImage` is a root-relative path (e.g. "/og/akki.png"); falls back to /og-default.png.
 * Renders <title>, description, canonical, OG, and Twitter card tags.
 */
export default function Seo({ title, description, path, ogImage }) {
  const url = `${SITE_HOST}${path}`;
  const ogPath = ogImage || DEFAULT_OG;
  const ogUrl = ogPath.startsWith("http") ? ogPath : `${SITE_HOST}${ogPath}`;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogUrl} />
      <meta property="og:image:width" content={String(OG_W)} />
      <meta property="og:image:height" content={String(OG_H)} />
      <meta property="og:site_name" content="Syni.ai" />
      <meta property="og:locale" content="en_GB" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogUrl} />
    </Helmet>
  );
}
